import Http from 'services/http2';
import User from 'services/user2';
import Modal from 'services/modal';
import BaseService from 'services/base';

const ScheduleService = Object.assign(
  {
    save(config: any = {}, cb: Function = () => {}, dispatch: Function) {},
    //确认发送排程
    handlePublish(postbody, cb: Function = () => {}, dispatch: Function) {
      let ok = () => {
        let config = {
          ...postbody,
          successMsg: '操作成功'
        };
        this.save(config, cb, dispatch);
      };
      Modal.showConfirm(
        '确定后，本交货计划将正式发布给所有相关供应商，发布后无法撤销，如需更改需发布新的计划。',
        ok,
        dispatch
      );
    },
    //排程差异确认
    async confirmSchedule(
      companyCode,
      batchBillNo,
      scheduleCpCode: string = '',
      cb: Function = () => {},
      dispatch: Function
    ) {
      let schItemNotAgreeCount = 0;
      let confirmMsg = '确认同意有差异的答交？';
      if (scheduleCpCode !== '') {
        let params = {
          companyCode: scheduleCpCode,
          billNo: batchBillNo[0],
          apiPath: '/schedule/schItemNotAgreeCount'
        };
        Modal.showLoading(dispatch);
        await Http.post('/api/cloudCenter?btnId=001', params).then(response => {
          Modal.hideLoading(dispatch);
          if (response.success) {
            schItemNotAgreeCount = response.data;
          }
        });
      }
      let ok = () => {
        let postbody = {
          companyCode,
          batchBillNo,
          apiPath: '/schedule/confirm'
        };
        Http.post('/api/cloudCenter?btnId=002', postbody).then(response => {
          if (response.success) {
            Modal.showTip('计划已确认', dispatch);
            cb();
          } else {
            Modal.showError(response.errorMsg, dispatch);
          }
        });
      };
      if (schItemNotAgreeCount > 0) {
        confirmMsg =
          '有' +
          { schItemNotAgreeCount } +
          '项差异不同意，确认后，不同意的项次系统会自动生成新的排程单。';
      }

      Modal.showConfirm(confirmMsg, ok, dispatch);
    },

    //退回供应商计划排程答交
    rejectScheduleReply(
      companyCode,
      billNo,
      cb: Function = () => {},
      dispatch: Function
    ) {
      let ok = (reason?) => {
        if (!reason) {
          Modal.showError('退回原因不能为空', dispatch);
          return;
        }
        let config = {
          companyCode,
          billNo,
          returnDesc: reason,
          apiPath: '/schedule/return'
        };
        this.save(config, cb, dispatch);
      };
      Modal.showReject(
        '您确定退回吗？',
        ok,
        '退回',
        'showReject',
        '',
        dispatch
      );
    }
  },
  BaseService
);

export default ScheduleService;
